/**
 * Grid registry — maps a table key (from data-grid="...") to its
 * library implementation and config module.
 *
 * Lazy imports so we only ship config for tables actually rendered.
 */
export const registry = {
  'block-analyzer': {
    lib: 'tabulator',
    load: () => import('./tabulator/lot_parts/block_analyzer.js'),
  },
  'combined-lots': {
    lib: 'tabulator',
    load: () => import('./tabulator/lot_parts/combined_lots.js'),
  },
  // Future tables:
  // 'air-rights': {
  //   lib: 'tabulator',
  //   load: () => import('./tabulator/lot_parts/air_rights.js'),
  // },
  // 'property-results': {
  //   lib: 'tabulator',
  //   load: () => import('./tabulator/search_results/properties.js'),
  // },
};
